'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaHourglassO = function FaHourglassO(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.4 2.9q0 5.8-2.3 10.3t-6 6.8q3.6 2.4 6 6.8t2.3 10.3h2.2q0.3 0 0.5 0.2t0.2 0.6v1.4q0 0.3-0.2 0.5t-0.5 0.2h-32.9q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.4 0.2-0.6t0.5-0.2h2.2q0-5.8 2.3-10.3t6-6.8q-3.6-2.4-6-6.8t-2.3-10.3h-2.2q-0.3 0-0.5-0.2t-0.2-0.6v-1.4q0-0.3 0.2-0.5t0.5-0.2h32.9q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.4-0.2 0.6t-0.5 0.2h-2.2z m-11.9 15.8q1.7-0.7 3.3-2.1t2.9-3.4 2.1-4.7 0.8-5.6h-22.9q0 2.9 0.8 5.6t2.1 4.7 2.9 3.4 3.3 2.1q0.4 0.1 0.7 0.5t0.2 0.8-0.2 0.8-0.7 0.5q-1.7 0.7-3.3 2.1t-2.9 3.4-2.1 4.7-0.8 5.6h22.9q0-2.9-0.8-5.6t-2.1-4.7-2.9-3.4-3.3-2.1q-0.4-0.1-0.7-0.5t-0.2-0.8 0.2-0.8 0.7-0.5z' })
        )
    );
};

exports.default = FaHourglassO;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/hourglass-o.js
// module id = 830
// module chunks = 168707334958949